import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Paper, Collapse, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../hooks/useApi';
import PageTitle from '../components/PageTitle';

export default function Objects() {
    const [locations, setLocations] = useState({});
    const [expanded, setExpanded] = useState({});
    const [loading, setLoading] = useState(true); // Состояние загрузки
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get('/api/locations-with-obj/get/');
                setLocations(response.data);
                // Initialize expanded state for each location
                const initialExpandedState = Object.keys(response.data).reduce((acc, city) => {
                    acc[city] = false;
                    return acc;
                }, {});
                setExpanded(initialExpandedState);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false); // Завершаем загрузку
            }
        }

        fetchData();
    }, []);

    const toggleExpand = (city) => {
        setExpanded((prevState) => ({
            ...prevState,
            [city]: !prevState[city],
        }));
    };

    if (loading) {
        // Показать спиннер, пока идет загрузка
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ padding: 2 }}>
            <PageTitle title="Мої локації" />
            <Grid container spacing={2}>
                {Object.entries(locations)
                    .filter(([city, objects]) => objects.length > 0) // Только локации с объектами
                    .map(([city, objects]) => (
                        <Grid item xs={12} md={6} lg={4} key={city}>
                            <Paper sx={{ padding: 2 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => toggleExpand(city)}
                                >
                                    <Typography variant="h6">{city}</Typography>
                                    <Button size="small">
                                        {expanded[city] ? 'Приховати' : 'Показати'}
                                    </Button>
                                </Box>
                                <Collapse in={expanded[city]}>
                                    <Box sx={{ marginTop: 2 }}>
                                        {objects.map((obj) => (
                                            <Paper
                                                key={obj.id}
                                                sx={{
                                                    padding: 2,
                                                    marginBottom: 1,
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => navigate(`/object/${obj.id}/details`)}
                                            >
                                                <Typography variant="subtitle1">
                                                    {obj.name}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    {obj.service_name}
                                                </Typography>
                                                <Typography variant="body2">
                                                    {obj.text_address}
                                                </Typography>
                                            </Paper>
                                        ))}
                                    </Box>
                                </Collapse>
                            </Paper>
                        </Grid>
                    ))}
            </Grid>
        </Box>
    );
}
